import * as React from 'react'

function TwoCardsIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width={80} height={79} fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <rect x={19.73} y={0.167} width={60.269} height={45.645} rx={4} fill='url(#prefix__paint0_linear_3701_8082)' />
      <path fill='#fff' fillOpacity={0.9} d='M19.73 8.725h60.269v8.558H19.73z' />
      <g filter='url(#prefix__filter0_bi_3701_8082)'>
        <rect y={32.855} width={60.269} height={45.645} rx={4} fill='#535353' fillOpacity={0.3} />
        <rect y={32.855} width={60.269} height={45.645} rx={4} fill='url(#prefix__paint1_linear_3701_8082)' />
      </g>
      <rect x={8.609} y={49.325} width={11.48} height={8.558} rx={2} fill='#fff' fillOpacity={0.9} />
      <rect x={8.74} y={66.441} width={8.61} height={5.706} rx={2.853} fill='#fff' fillOpacity={0.9} />
      <rect x={20.22} y={66.441} width={8.61} height={5.706} rx={2.853} fill='#fff' fillOpacity={0.9} />
      <rect x={31.7} y={66.441} width={8.61} height={5.706} rx={2.853} fill='#fff' fillOpacity={0.9} />
      <rect x={43.18} y={66.441} width={8.61} height={5.706} rx={2.853} fill='#fff' fillOpacity={0.9} />
      <defs>
        <linearGradient
          id='prefix__paint0_linear_3701_8082'
          x1={8.735}
          y1={-4.469}
          x2={90.573}
          y2={38.874}
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#46C8E0' />
          <stop offset={1} stopColor='#52D878' />
        </linearGradient>
        <linearGradient
          id='prefix__paint1_linear_3701_8082'
          x1={66.643}
          y1={68.094}
          x2={-14.831}
          y2={46.185}
          gradientUnits='userSpaceOnUse'
        >
          <stop offset={0.458} stopColor='#969696' stopOpacity={0} />
          <stop offset={1} stopColor='#36E0FF' />
        </linearGradient>
        <filter
          id='prefix__filter0_bi_3701_8082'
          x={-6}
          y={26.855}
          width={72.269}
          height={57.645}
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity={0} result='BackgroundImageFix' />
          <feGaussianBlur in='BackgroundImageFix' stdDeviation={3} />
          <feComposite in2='SourceAlpha' operator='in' result='effect1_backgroundBlur_3701_8082' />
          <feBlend in='SourceGraphic' in2='effect1_backgroundBlur_3701_8082' result='shape' />
          <feColorMatrix in='SourceAlpha' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0' result='hardAlpha' />
          <feOffset dx={0.2} dy={0.1} />
          <feGaussianBlur stdDeviation={1.5} />
          <feComposite in2='hardAlpha' operator='arithmetic' k2={-1} k3={1} />
          <feColorMatrix values='0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0' />
          <feBlend in2='shape' result='effect2_innerShadow_3701_8082' />
        </filter>
      </defs>
    </svg>
  )
}

export default TwoCardsIcon
